import { FormControlLabel } from '@mui/material';
import Select, { SelectProps } from '@mui/material/Select/Select';
import { ReactNode } from 'react';

export const MHMSelect = <T,>(props: SelectProps<T>) => {
  return <Select {...props} />;
};

export function MHMLabelledSelect<T>(props: {
  selectProps: SelectProps<T>;
  label: ReactNode;
  children?: ReactNode;
}) {
  return (
    <FormControlLabel
      sx={{ marginLeft: 0, marginRight: 0 }}
      label={props.label}
      labelPlacement="start"
      control={
        <MHMSelect<T> {...props.selectProps}>{props.children}</MHMSelect>
      }
    />
  );
}
